import { render, staticRenderFns } from "./CompareTheMarketCarFinanceLogo.vue?vue&type=template&id=2bedafe9&scoped=true"
import script from "./CompareTheMarketCarFinanceLogo.vue?vue&type=script&lang=js"
export * from "./CompareTheMarketCarFinanceLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedafe9",
  null
  
)

export default component.exports